import { Component, Input, OnInit } from '@angular/core';
import { GeneralService } from '@ex/module/core/services/general.service';
import { QuestionnaireScale } from '@ex/module/core/services/questionnaire-scale-setup.service';

@Component({
  selector: 'question-confidence',
  templateUrl: './confidence.component.html',
  styleUrls: ['./confidence.component.scss']
})
export class ConfidenceComponent implements OnInit {
  @Input() scales: QuestionnaireScale;
  @Input() question;
  @Input() language;
  constructor(private generalService: GeneralService) { }
  
  ngOnInit(): void {
  }


  questionAnswer(answer) {
    console.log(this.question);

    this.question.answer = answer;
  }

  getConfidence(subquestionKey: string, key: string) {
    return this.generalService.getQuestionOptions(subquestionKey, key, this.language);
  }
}
